/**
 * Business information constants for invoices
 */

export const BUSINESS_INFO = {
  name: 'VIVA Psychotherapy LLC',
  phone: '(561) 759-7519',
  email: 'info@vivapsychotherapy.com',
  address: '5301 North Federal Highway Suite 200',
  city: 'Boca Raton',
  state: 'FL',
  zipCode: '33487',
  website: 'https://www.vivapsychotherapy.com/'
}

export function getBusinessAddress() {
  return `${BUSINESS_INFO.address}, ${BUSINESS_INFO.city}, ${BUSINESS_INFO.state} ${BUSINESS_INFO.zipCode}`
}

export function getBusinessFullAddress() {
  return {
    line1: BUSINESS_INFO.address,
    city: BUSINESS_INFO.city,
    state: BUSINESS_INFO.state,
    zipCode: BUSINESS_INFO.zipCode
  }
}

/**
 * Reservation window utilities
 * Reservations can be made up to N months ahead (configurable, default 1 month)
 */

/**
 * Get the start of the reservation window (today)
 * @param {number} windowMonths - Number of months for the window (default: 1)
 * @returns {Date} Today at 00:00:00
 */
export function getReservationWindowStart(windowMonths = 1) {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0)
}

/**
 * Get the end of the reservation window (N months from today)
 * @param {number} windowMonths - Number of months for the window (default: 1)
 * @returns {Date} End of N months from today at 23:59:59.999
 */
export function getReservationWindowEnd(windowMonths = 1) {
  const now = new Date()
  // Get first day of month N months ahead
  const targetMonth = new Date(now.getFullYear(), now.getMonth() + windowMonths, 1, 0, 0, 0, 0)
  // Get last day of that month
  const lastDay = new Date(targetMonth.getFullYear(), targetMonth.getMonth() + 1, 0, 23, 59, 59, 999)
  return lastDay
}

/**
 * Check if a date is within the reservation window
 * @param {Date} date - The date to check
 * @param {number} windowMonths - Number of months for the window (default: 1)
 * @returns {boolean} True if date is within the window
 */
export function isWithinReservationWindow(date, windowMonths = 1) {
  const windowStart = getReservationWindowStart(windowMonths)
  const windowEnd = getReservationWindowEnd(windowMonths)
  return date >= windowStart && date <= windowEnd
}

/**
 * Get the minimum date string for HTML date inputs (YYYY-MM-DD)
 * @param {number} windowMonths - Number of months for the window (default: 1)
 * @returns {string} Minimum date in YYYY-MM-DD format (today)
 */
export function getReservationWindowMinDate(windowMonths = 1) {
  const start = getReservationWindowStart(windowMonths)
  const year = start.getFullYear()
  const month = String(start.getMonth() + 1).padStart(2, '0')
  const day = String(start.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Get the maximum date string for HTML date inputs (YYYY-MM-DD)
 * @param {number} windowMonths - Number of months for the window (default: 1)
 * @returns {string} Maximum date in YYYY-MM-DD format
 */
export function getReservationWindowMaxDate(windowMonths = 1) {
  const end = getReservationWindowEnd(windowMonths)
  const year = end.getFullYear()
  const month = String(end.getMonth() + 1).padStart(2, '0')
  const day = String(end.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
